import { getCrossBrowserFullscreenElement } from 'util/fullscreen';
import { observer } from 'mobx-react-lite';
import { selectFirstScreenSharingTrack, selectIsScreenShared } from 'state/selectors';
import { useSort } from '../hooks/useSort';
import { StageProps } from '../types';
import { MobileSpeakerStage } from './MobileSpeakerStage';
import { MobileScreenShareStage } from './MobileScreenShareStage';
import { MobileFullScreenShareStage } from './MobileFullScreenShareStage';

export const MobileStage = observer(
    ({ roomState, participantRenderer, controlRenderer, onLeave, hasRecorder }: StageProps) => {
        const isScreenShared = selectIsScreenShared();
        const screenTrack = selectFirstScreenSharingTrack();
        const { getSortedParticipantsWhenFocused } = useSort();
        const sortedParticipants = getSortedParticipantsWhenFocused();
        const isScreenShareMode = isScreenShared && screenTrack;

        // Выводим нужный шаблон для спикера, шаринга или шаринга на весь экран
        const fullscreenElement = getCrossBrowserFullscreenElement();
        if (isScreenShareMode && Boolean(fullscreenElement)) {
            return (
                <MobileFullScreenShareStage
                    roomState={roomState}
                    participantRenderer={participantRenderer}
                    controlRenderer={controlRenderer}
                    onLeave={onLeave}
                    hasRecorder={hasRecorder}
                    participants={sortedParticipants}
                    screenTrack={screenTrack}
                />
            );
        }

        if (isScreenShareMode) {
            return (
                <MobileScreenShareStage
                    roomState={roomState}
                    participantRenderer={participantRenderer}
                    controlRenderer={controlRenderer}
                    onLeave={onLeave}
                    hasRecorder={hasRecorder}
                    participants={sortedParticipants}
                    screenTrack={screenTrack}
                />
            );
        }

        return (
            <MobileSpeakerStage
                roomState={roomState}
                participantRenderer={participantRenderer}
                controlRenderer={controlRenderer}
                onLeave={onLeave}
                hasRecorder={hasRecorder}
                participants={sortedParticipants}
            />
        );
    },
);

MobileStage.displayName = 'MobileStage';
